import { LatestTestExecution } from '@elementary/common-ui/services/gql/types';
import {
  TestResultsGroup,
  Totals,
  TotalTypes,
} from '@elementary/common-ui/types';

export const statusMap: Record<string, TotalTypes> = {
  pass: TotalTypes.passed,
  fail: TotalTypes.errors,
  warn: TotalTypes.warnings,
  error: TotalTypes.errors,
  skipped: TotalTypes.noData,
  no_data: TotalTypes.noData,
};

const emptyTestResultsGroup = (): TestResultsGroup => ({
  [TotalTypes.errors]: [],
  [TotalTypes.warnings]: [],
  [TotalTypes.passed]: [],
  [TotalTypes.failures]: [],
  [TotalTypes.noData]: [],
});

export const emptyTotals = (): Totals => ({
  [TotalTypes.errors]: 0,
  [TotalTypes.warnings]: 0,
  [TotalTypes.passed]: 0,
  [TotalTypes.failures]: 0,
  [TotalTypes.noData]: 0,
});

export const getTestResultsGroup = (
  executions: LatestTestExecution[] | undefined,
): TestResultsGroup => {
  if (!executions) return emptyTestResultsGroup();

  return executions.reduce((acc, { test, execution }) => {
    const statusKey = statusMap[execution.status];
    if (statusKey) {
      acc[statusKey].push(test.name);
    }
    return acc;
  }, emptyTestResultsGroup());
};

export const compareByTestResultsTotals = (
  totalsA: Totals | undefined,
  totalsB: Totals | undefined,
): number => {
  const scoreA = (totalsA?.errors || 0) + (totalsA?.failures || 0);
  const scoreB = (totalsB?.errors || 0) + (totalsB?.failures || 0);
  if (scoreA !== scoreB) return scoreA - scoreB;
  const passedDiff = (totalsA?.passed || 0) - (totalsB?.passed || 0);
  if (passedDiff !== 0) return passedDiff;
  return (totalsA?.noData || 0) - (totalsB?.noData || 0);
};

export const getTestExecutionTotals = (
  executions: LatestTestExecution[] | undefined,
): Totals => {
  if (!executions) return emptyTotals();

  return executions.reduce((acc, { execution }) => {
    const statusKey = statusMap[execution.status];
    if (statusKey) {
      acc[statusKey] += 1;
    }
    return acc;
  }, emptyTotals());
};
